import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { PILLARS } from "../../config/site";
import { Landmark, HardHat, Network, Handshake } from "lucide-react";

const ICONS = [Landmark, HardHat, Network, Handshake];

export const About = () => (
  <Section id="about" overline="About the developer" title="We don't sell plots. We build ready ecosystems.">
    <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
      <Reveal>
        <div>
          <p className="font-display text-2xl sm:text-3xl leading-snug text-forest-light italic">
            "Factories should start faster — with faster execution and less hassle. That is the
            whole idea behind BIDC."
          </p>
          <p className="mt-6 text-base leading-relaxed text-[#4A4C4A]">
            Tirupati Developers is an industrial-focused developer with Bhiwani as home base. We
            know this land, its people and its industry — and we have built BIDC so that an
            entrepreneur can go from booking to production without fighting the system.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#4A4C4A]">
            Land, approvals, infrastructure, finance and subsidies — the four things that slow a
            factory down — are handled at the estate level, before you ever break ground.
          </p>
        </div>
      </Reveal>
      <div className="grid gap-4 sm:grid-cols-2">
        {PILLARS.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={p.title} delay={i * 0.08}>
              <div
                className="h-full border border-border bg-paper-light p-6 transition-transform duration-200 hover:-translate-y-1"
                data-testid={`pillar-${i}`}
              >
                <Icon className="h-7 w-7 text-gold" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-xl font-medium text-forest">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4A4C4A]">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </Section>
);
